module.exports = __webpack_public_path__ + "img/prize-03.eea60b73.png";